import { AVAILABLE_SEARCH_RULES_TYPES, FIELD_VALUE_TYPE, SEARCH_RULE_TYPE } from '@constants'
import { ConfiguredColumn } from '@types'

export const getIsAvailableRuleByType = (column: ConfiguredColumn, rule: SEARCH_RULE_TYPE) => {
  if (!column || column.isPk) {
    return false
  }

  if (column.pathArray?.length) {
    const lastField = column.pathArray[column.pathArray.length - 1]

    if (lastField.isPk) return false
    //TODO: возможно нужно дополнительное сравнение по objectFieldType
    return AVAILABLE_SEARCH_RULES_TYPES[rule].fieldValueTypes.includes(lastField.valueType)
  }

  return (
    column.valueType &&
    column.fieldType &&
    AVAILABLE_SEARCH_RULES_TYPES[rule].fieldValueTypes.includes(column.valueType) &&
    AVAILABLE_SEARCH_RULES_TYPES[rule].objectFieldTypes.includes(column.fieldType)
  )
}

export const getIsAvailableRuleByTypeForValueType = (
  valueType: FIELD_VALUE_TYPE,
  rule: SEARCH_RULE_TYPE
) => {
  return AVAILABLE_SEARCH_RULES_TYPES[rule].fieldValueTypes.includes(valueType)
}
